import ICONS from "../icons";
import { pillars } from "../../data/siteContent";

const heroMetrics = [
  {
    value: "3",
    label: "worlds we build brands for: leaders, students and professionals",
    testid: "hero-metric-one",
  },
  {
    value: "7 Years",
    label: "of brand and content experience leading our team",
    testid: "hero-metric-two",
  },
  {
    value: "3",
    label: "platforms working as one system: LinkedIn, Instagram and YouTube",
    testid: "hero-metric-three",
  },
];

const systemTags = ["Strategy", "Content", "Design", "Distribution"];

const presenceChannels = [
  { icon: "Linkedin", label: "LinkedIn" },
  { icon: "Instagram", label: "Instagram" },
  { icon: "Youtube", label: "YouTube" },
  { icon: "Mail", label: "Newsletter" },
  { icon: "Video", label: "Video" },
  { icon: "School", label: "Campus" },
];

export const Hero = ({ scrollToSection }) => (
  <header className="hero" id="hero" data-testid="hero-section">
    <div className="hero-grid" data-testid="hero-grid">
      <div className="hero-copy" data-testid="hero-copy">
        <div className="hero-badge" data-testid="hero-badge">
          <ICONS.Sparkles className="icon" data-testid="hero-badge-icon" />
          Communications and Brand Growth Partner
        </div>
        <h1 className="hero-title" data-testid="hero-title">
          One partner. <span className="text-gradient">Three worlds.</span> A
          single voice people trust.
        </h1>
        <p className="hero-subtitle" data-testid="hero-subtitle">
          Vartalab builds personal and company brands for the leaders,
          students and independent professionals shaping the next decade of
          business. Whichever world you belong to, we turn conversation into
          growth.
        </p>
        <div className="hero-actions" data-testid="hero-actions">
          <button
            className="cta-button large"
            onClick={() => scrollToSection("leaders")}
            data-testid="hero-primary-cta"
          >
            Explore the Three Pillars
          </button>
          <button
            className="ghost-button"
            onClick={() => scrollToSection("contact")}
            data-testid="hero-secondary-cta"
          >
            Talk to Vartalab
          </button>
        </div>
        <p className="hero-note" data-testid="hero-note">
          Vartalab takes its name from vartalaap, the everyday word for
          conversation. Everything we build starts with a real one.
        </p>
        <div className="hero-metrics" data-testid="hero-metrics">
          {heroMetrics.map((metric) => (
            <div
              className="metric-card"
              key={metric.testid}
              data-testid={metric.testid}
            >
              <span data-testid={`${metric.testid}-value`}>
                {metric.value}
              </span>
              <p data-testid={`${metric.testid}-label`}>{metric.label}</p>
            </div>
          ))}
        </div>
        <div className="hero-pillars" data-testid="hero-pillar-cards">
          {pillars.map((pillar) => {
            const PillarIcon = ICONS[pillar.icon];
            return (
              <button
                key={pillar.id}
                className="hero-pillar-card"
                style={{ "--pillar-accent": pillar.accent }}
                onClick={() => scrollToSection(pillar.id)}
                data-testid={`hero-pillar-card-${pillar.id}`}
              >
                <PillarIcon className="hero-pillar-icon" aria-hidden="true" />
                <span data-testid={`hero-pillar-card-${pillar.id}-label`}>
                  {pillar.navLabel}
                </span>
                <ICONS.ArrowRight className="hero-pillar-arrow" aria-hidden="true" />
              </button>
            );
          })}
        </div>
      </div>
      <div className="hero-panel" data-testid="hero-panel">
        <div className="panel-card primary" data-testid="hero-panel-primary">
          <div className="panel-header" data-testid="hero-panel-primary-header">
            <span data-testid="hero-panel-primary-title">Vartalab System</span>
          </div>
          <h3 data-testid="hero-panel-primary-metric">Strategy to Publish</h3>
          <p data-testid="hero-panel-primary-text">
            One connected process runs behind every pillar we deliver.
          </p>
          <div className="panel-tags" data-testid="hero-panel-primary-tags">
            {systemTags.map((tag) => (
              <span key={tag} data-testid={`hero-panel-tag-${tag.toLowerCase()}`}>
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="panel-card" data-testid="hero-panel-secondary">
          <h4 data-testid="hero-panel-secondary-title">Where we show up</h4>
          <div className="format-list" data-testid="hero-panel-secondary-list">
            {presenceChannels.map((channel) => {
              const ChannelIcon = ICONS[channel.icon];
              return (
                <span
                  className="format-pill"
                  key={channel.label}
                  data-testid={`hero-format-${channel.label.toLowerCase()}`}
                >
                  <ChannelIcon className="format-pill-icon" aria-hidden="true" />
                  {channel.label}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </header>
);
